import { render, staticRenderFns } from "./HealthcheckReminderDialog.vue?vue&type=template&id=2a8e262c&scoped=true"
import script from "./HealthcheckReminderDialog.vue?vue&type=script&lang=js"
export * from "./HealthcheckReminderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e262c",
  null
  
)

export default component.exports